import { Loader2 } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

export const Spinner = () => (
  <div className="flex justify-center py-12 text-muted-foreground"><Loader2 className="size-5 animate-spin" /></div>
);

export const TableSkeleton = ({ rows = 5 }: { rows?: number }) => (
  <div className="space-y-2 p-4">
    {Array.from({ length: rows }, (_, i) => <Skeleton key={i} className="h-8 w-full" />)}
  </div>
);
